import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { DEFAULT_ROSTER_PAGE_SIZE } from '~/modules/artist-roster/constants';
import { getArtists } from '~/modules/artist-roster/lib/artists';

interface ArtistQueryProps {
  searchText?: string;
  labelIds: number[];
  isCrossover: boolean;
  isOnRoster?: boolean;
  pageNumber: number;
}

export function useArtistQuery({
  searchText,
  labelIds,
  isCrossover,
  isOnRoster,
  pageNumber,
}: ArtistQueryProps) {
  return useQuery({
    queryKey: [
      'artist-roster',
      searchText,
      labelIds,
      isCrossover,
      isOnRoster,
      pageNumber,
    ],
    queryFn: ({ signal }) => {
      return getArtists({
        offset: (pageNumber - 1) * DEFAULT_ROSTER_PAGE_SIZE,
        limit: DEFAULT_ROSTER_PAGE_SIZE,
        search: searchText,
        labels: labelIds,
        isCrossover,
        isOnRoster,
        signal,
      });
    },
    placeholderData: keepPreviousData,
  });
}
